/// <amd-module name="DistributedTask/Flux/Actions" />
import { Initializable } from "DistributedTask/Flux/Factory";
import { Action as BaseAction } from "VSS/Reflux/Action";

export interface IEmptyActionPayload {
}

export interface IActionPayload {
}

export abstract class ActionCreatorBase extends Initializable {
}

export abstract class ActionsHubBase extends Initializable {
}

export class Action<T> extends BaseAction<T> {
}
